<template>
  <div v-show='isMap' class='properties-map'>
    <div class='properties-map__map'></div>
    <div class='properties-map__popup'>
      <a class='properties-map__popup-close' @click='clearActiveMarker'><i class='icon-close'/></a>
      <div v-if='currentMarkerContent' v-html="currentMarkerContent" class='properties-map__popup-content properties-map__popup-info'></div>
    </div>
  </div>
</template>

<script>
  import querystring from 'querystring';
  import {mapGetters} from 'vuex';

  export default {
    data() {
      return {
        nearby: null,
        map: null,
        minPrice: null,
        maxPrice: null,
        minNumberOfBedrooms: null,
        furnishing: 0,
        googleMarkers: [],
        windowWidth: 0,
        filterShowed: true,
        currentMarkerContent: null,
        activeMarker: null,
      };
    },
    computed: {
      ...mapGetters(['locales']),
      coordinates() {
        return this.$store.getters.getMapCoordinates;
      },
      markers() {
        return this.$store.getters.getMapMarkers;
      },
      isMap: function() {
        return this.$store.getters.getSearchprofilesIsMap;
      },
    },
    props: {
      websiteId: {
        default: 1,
        type: Number,
      },
    },
    methods: {
      codeAddress() {
        var searchParams = location.search;
        if(searchParams == ''){
          searchParams = '?map=1';
        }else{
          searchParams = searchParams+'&map=1'
        }
        window.axios
          .get(
            '/api/map-searches' +searchParams,
          )
          .then(response => {
            if (response.data && response.data.searches && response.data.searches.length) {
              let pt = new google.maps.LatLng(response.data.searches[0].latitude, response.data.searches[0].longitude);
              this.map.setCenter(pt);
            } else if (response.data && response.data.center) {
              let pt = new google.maps.LatLng(response.data.center.lat, response.data.center.lng);
              this.map.setCenter(pt);
            }

            let markers = [];

            _.each(response.data.searches, searchprofile => {
              let marker = {
                latitude: parseFloat(searchprofile.latitude),
                longitude: parseFloat(searchprofile.longitude),
                information: searchprofile.map_marker
              };

              markers.push(marker);
            });
            this.$store.commit('SET_MAP_MARKERS', markers);
          });
      },
      setMarker(markerData) {
        var min = .999999;
        var max = 1.000001;
        const defaultIcon = {
          url: '/images/marker.png',
          size: new google.maps.Size(48, 48),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(24, 48),
          scaledSize: new google.maps.Size(48, 48)
        };

        const activeIcon = {
          url: '/images/marker-active.png',
          size: new google.maps.Size(48, 48),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(24, 48),
          scaledSize: new google.maps.Size(48, 48)
        };

        var marker = new google.maps.Marker({
          // position: {lat: (markerData[1]* (Math.random() * (max - min) + min)), lng: (markerData[2]* (Math.random() * (max - min) + min))},
          position: {lat: markerData[1], lng: markerData[2]},
          map: this.map,
          icon: this.activeMarker === marker ? activeIcon : defaultIcon,
          title: markerData[0],
          html: markerData[3],
          markerData: markerData,
          url: markerData[5]
        });
        marker.addListener('click', () => {
          if (this.activeMarker && this.activeMarker !== marker) {
            this.activeMarker.setIcon(defaultIcon);
          }
          marker.setIcon(activeIcon);
          this.activeMarker = marker;
          this.currentMarkerContent = marker.html;
        });

        return marker;
      },
      clearActiveMarker() {
        const defaultIcon = {
          url: '/images/marker.png',
          size: new google.maps.Size(48, 48),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(24, 48),
          scaledSize: new google.maps.Size(48, 48)
        };
        this.activeMarker.setIcon(defaultIcon);
        this.currentMarkerContent = null;
      },
    },
    mounted() {
      if (this.detail) {
        var w_zoom = 11,
          w_lon = 0,
          w_lat = 0;
      } else {
        if (this.websiteId == '2') {
          var w_lat = 51.795027225829145,
            w_lon = 5.537109375,
            w_zoom = 8;
        } else {
          var w_lat = 51.924420,
            w_lon = 4.477733,
            w_zoom = 12;
        }
      }
      this.map = new google.maps.Map(document.querySelector('.properties-map__map'), {
        zoom: w_zoom,
        maxZoom: 16,
        center: new google.maps.LatLng(w_lat, w_lon),
        mapTypeControl: false,
        mapTypeControlOptions: {style: google.maps.MapTypeControlStyle.DROPDOWN_MENU, position: google.maps.ControlPosition.RIGHT_BOTTOM},
        navigationControl: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: true,
        fullscreenControl: false,
        styles: [
          {
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#f5f5f5"
              }
            ]
          },
          {
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          },
          {
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#f5f5f5"
              }
            ]
          },
          {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#bdbdbd"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#eeeeee"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e5e5e5"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#ffffff"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#dadada"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          },
          {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e5e5e5"
              }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#eeeeee"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#c9c9c9"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          }
        ]
      });
      this.codeAddress(this.map, 'Netherlands');
    },
    watch: {
      coordinates() {
        if (!this.map) {
          return;
        }

        this.map.setCenter({
          lat: this.coordinates.latitude,
          lng: this.coordinates.longitude
        });
      },
      markers(collection) {
        if (!this.map) {
          return;
        }

        _.each(collection, marker => {
          this.googleMarkers.push(
            this.setMarker([marker.name, marker.latitude, marker.longitude, marker.information, marker.markerData, marker.url]),
          );
        });
      },
    },
  };
</script>
